import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import { InputItem, List, Button, WhiteSpace, Toast } from 'antd-mobile'
import { createForm } from 'rc-form';
import { UrlSearch, formatBillUnit } from '../../../utils/utils'
import { formatAmount } from '../utils/common'
import { GetCompanyList, AddFreeAmount as AddFreeAmountApi, CancelFreeAmount as CancelFreeAmountApi } from '../../../api/usms'
import CompanyDetail from '../components/CompanyDetail';
import { AclKeys } from '../utils/permissions';
import Permission from '../components/Permission';

// 传递id，获取当前用户详情
function AddFreeAmount(props) {

  const [companyInfo, setCompanyInfo] = useState({})
  const [loading, setLoading] = useState(true)
  const [confirmLoading, setConfirmLoading] = useState(false)

  const { getFieldProps, getFieldError } = props.form;
  const CompanyId = useMemo(() => {
    return UrlSearch("CompanyId")
  }, []);

  const Type = useMemo(() => {
    return UrlSearch("Type")
  }, []);

  const isCancel = useMemo(() => Type === 'cancel', [Type]);

  const errors = getFieldError('AmountFree')

  if (!CompanyId) {
    props.history.push(`/usms/companylist`)
  }

  const getList = useCallback((data) => {
    setLoading(true);
    GetCompanyList(data).then(res => {
      const { Data, Message } = res;
      if (Data && Data.length) {
        const info = Data[0]
        setCompanyInfo(info);
      } else {
        Toast.fail(Message, 3);
      }
      setLoading(false);
    }).catch(e => {
      Toast.fail(e.message, 3);
      setLoading(false);
    });
  }, [])

  const onCancel = () => {
    props.history.push(`/usms/companylist`)
  }

  const onConfirm = () => {
    props.form.validateFields((error, value) => {
      if (!error) {
        const { AmountFree } = value
        handleAddFreeAmount({
          CompanyId: companyInfo.CompanyId,
          AmountFree: formatAmount(Number(AmountFree))
        })
      }
    });
  }

  const handleAddFreeAmount = (data) => {
    setConfirmLoading(true);
    const request = isCancel ? CancelFreeAmountApi : AddFreeAmountApi;
    request(data).then(res => {
      const { RetCode, Message } = res;
      if (RetCode !== 0) {
        Toast.fail(Message, 3);
      } else {
        Toast.success(`${isCancel ? '取消' : '发放'}成功`, 3)
        getList({ CompanyIds: [Number(CompanyId)] })
      }
      setConfirmLoading(false)
    }).catch(err => {
      Toast.fail(err.message, 3);
      setConfirmLoading(false)
    })
  }

  useEffect(() => {
    getList({ CompanyIds: [Number(CompanyId)] })
  }, [getList])

  return <>
    {loading ? <div>
      loading...
    </div> : <div className="container">
      <h3 style={{ paddingLeft: '10px', paddingBottom: '5px' }}>赠金{isCancel ? '取消' : '发放'}</h3>
      <Permission aclKey={AclKeys.SMSBonus}>
        <CompanyDetail detailInfo={companyInfo} />
        <List>
          <InputItem
            disabled
            {...getFieldProps('Email', {
              initialValue: companyInfo.Email
            })}
          >当前用户</InputItem>
          <InputItem
            disabled
            {...getFieldProps('CurrentFreeAmount', {
              initialValue: `${companyInfo.Currency.toUpperCase()} ${formatBillUnit(companyInfo.AmountFree)}`
            })}
          >当前赠金</InputItem>
          <InputItem
            {...getFieldProps('AmountFree', {
              rules: [{
                required: true,
                type: 'number',
                validator: (_, value) => {
                  const reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,4})?$/
                  if (reg.test(value)) {
                    return true
                  }
                  return false
                },
                message: '金额不合法，最多4位小数'
              }]
            })}
            placeholder="单位美元，最多4位小数"
          >{isCancel ? '取消' : '发放'}赠金</InputItem>
          <p style={{ color: 'red', paddingLeft: '16px' }}>{errors ? errors.join(',') : null}</p>
        </List>
        <WhiteSpace />
        <WhiteSpace />
        <WhiteSpace />
        <Button loading={confirmLoading} onClick={onConfirm} type="primary">确定</Button><WhiteSpace />
        <Button onClick={onCancel}>返回</Button><WhiteSpace />
      </Permission>
    </div>}
  </>
}
export default createForm()(withRouter(AddFreeAmount))